// Raised when a filter compiler cannot turn a control's raw text into a wire
// predicate. Compilers must FAIL rather than omit the predicate: omitting it
// BROADENS the query, and the wider audience gets searched, imported and
// enriched with nothing on screen to say so.
//
// Dependency-light on purpose (no React, no store) so the compilers, the hooks
// that dispatch them and the inputs that surface them can all share it.

export class FilterCompileError extends Error {
  constructor(
    /** The ``SearchFilters`` / ``CompanySearchFilters`` key that failed. */
    readonly field: string,
    /** Human label for that control. */
    readonly label: string,
    /** Underlying parser message. */
    readonly reason: string
  ) {
    super(`${label}: ${reason}`);
    this.name = 'FilterCompileError';
  }
}

export function isFilterCompileError(
  error: unknown
): error is FilterCompileError {
  return error instanceof FilterCompileError;
}

/** Message for an existing inline/save surface; other errors keep `fallback`. */
export function filterCompileErrorMessage(
  error: unknown,
  fallback: string
): string {
  return isFilterCompileError(error)
    ? `${error.message} Fix it and try again.`
    : fallback;
}
